import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getLandingRoute } from '../access';

/**
 * The `/` route: Inicio for a user who receives tasks, the chat for everybody
 * else. On a fresh page load the session is not in Redux yet, so it goes to
 * the chat exactly as before; the login and magic-link flows decide the
 * landing with the same helper once the session is known.
 */
const LandingRedirect = () => {
  const userData = useSelector((state) => state.user && state.user.data);
  return <Redirect to={getLandingRoute(userData && userData.id ? userData : null)} />;
};

export default LandingRedirect;
